import {Component, Input} from '@angular/core';
import {NgClass} from "@angular/common";

@Component({
  selector: 'form-text',
  standalone: true,
    imports: [
        NgClass
    ],
  templateUrl: './form-text.component.html',
  styleUrl: './form-text.component.scss'
})
export class FormTextComponent {
    @Input() subtitle!: string;
    @Input() alignLeft: boolean = false;
}
